// @flow

import * as types from '../ACTIONS/commonActionTypes';
import initialState from './commonInitialState';
import LIUtils from "../SUPPORT/LIUtils";

export default function clientReducer(state = initialState.clientInfo, ourClientId:number, action) {

    switch (action.type) {
        case types.SET_CLIENT_ID: { // this is for user info when connected to a device FIRMWARE (different id)
            if(!LIUtils.hasGoodClientId(state.clientId) || 
                !LIUtils.hasGoodClientId(action.clientId)) { // we are waiting for one or we're are being told to reset ours (shutdown)
                const newState = {...state}
                newState.clientId = action.clientId;
                return (newState);
            }
            return(state);
        }
        case types.SET_CLIENT_INFO: { // this is for user info if connected directly to the ARCHIVER
            const newState = {...state}
            newState.userId = action.userId;
            newState.fullName = action.fullName;
            newState.level = action.level;
            return (newState);
        }
        case types.GOT_LOGIN_UPDATE: {
            if(ourClientId===-1 || ourClientId===action.fromClientId) {
                console.debug("GOT_LOGIN_UPDATE -- this is for us ");

                const newState = {...state}
                newState.isLoggedInToFW = action.result === "success";
                return (newState);
            }
            return state; // no change
        }
        case types.GOT_LOGOUT_UPDATE: {
            if(ourClientId===action.fromClientId || action.fromClientId===0) {
                console.debug("GOT_LOGOUT_UPDATE -- this is for us (or from system)");
                const newState = {...state}
                newState.isLoggedInToFW = false;
                return (newState);
            }
            return state; // no change
        }
        case types.GOT_FIRMWARE_ERROR: {    // send on any error
            if(action.origin==="login") { // this error is for us (some login issue at the fw)
                return({...initialState.clientInfo});       // kick everybody out
            }
            //break;    // this causes 'globalState.clientInfo.clientId' to be 'undefined'
            return (state); // no change
        }
        default:
            return(state);
    }
}

